L.Control.LocationHash = L.Control.extend({

    options: {
       position: 'bottomright',
       undoEnabled: true
    },

    undoHistory: [],

    initialize: function (options) {
       L.setOptions(this, options);
    },

    onAdd: function (map) {
       this._container = L.DomUtil.create('div', 'leaflet-control-undo leaflet-bar');
       this._link = L.DomUtil.create('a','leaflet-bar-part leaflet-bar-part-single',this._container);
       this._link.href = "#";
       this._link.title = 'Undo';
       L.DomUtil.create('i','fa fa-undo', this._link);
       L.DomEvent.on(this._link, 'click', L.DomEvent.preventDefault)
                 .on(this._link, 'click', L.DomEvent.stopPropagation)
                 .on(this._link, 'click', this._undo, this);
       return this._container;
    },

    // Undo
    _undo: function() {

       if (!this.options.undoEnabled)
          return;

       if (this.undoHistory.length < 1)
          return;

       var url = this.undoHistory.pop();
       if (url == "")
          url = "#";

       window.location = url;
    },

    _pushUndo: function() {

       var newval = window.location.hash == '' ? '#' : window.location.hash;

       // if existing val matches new val, then don't add a duplicate
       if (this.undoHistory.length > 0) {
          if (this.undoHistory[this.undoHistory.length-1] == newval) {
             return;
          }
       }

       this.undoHistory.push(newval);
       if (this.undoHistory.length >= 10) {
          this.undoHistory.shift();
       }
     },

    // Update browser location hash
    updateLocationHash: function() {
       var hash = [],
           locs = [],
           skipSegments = [],
           plan = control.getPlan(),
           waypoints = control.getPlan().getWaypoints(),
           route = control._selectedRoute;

       var items = {
          rt: plan.getRoundTrip(),
          td: plan.getTargetDistance(),
          aus: plan.getAvoidUnlitStreets(),
          aus2: plan.getAvoidUnsafeStreets(),
          ah: plan.getHillPreference(),
          ar: route && route.overriddenParameters && typeof route.overriddenParameters.avoidRepetition !== "undefined" ? route.overriddenParameters.avoidRepetition : plan.getAvoidRepetition(),
          pga: plan.getGreenPreference(),
          im: plan.getImperialUnits()
       };

       for (var i = 0; i < waypoints.length; i++) {
          if (waypoints[i].latLng) {
             locs.push(waypoints[i].latLng.lat.toFixed(5) + ',' + waypoints[i].latLng.lng.toFixed(5));
             if (waypoints[i].options.straightLines) {
                skipSegments.push(i);
             }
          }
       }

       hash.push('wps='+locs.join('%7C'));
       hash.push('ss='+skipSegments.join(','));

       for (var k in items) {
          hash.push(k+'='+items[k]);
       }

       var hashval = '#'+hash.join('&');

       // empty URL if no locations specified
       if (locs.length == 0)
          hashval = '#';

       var existing = window.location.hash == '' ? '#' : window.location.hash;

       // don't push if there's been no change
       if (hashval == existing)
          return;

       this._pushUndo();
       history.replaceState(null, null, hashval);
    },

    // returns true if a valid route can be plotted
    applyLocationHash: function() {

       var contents = window.location.hash.replace(/^#*/,'');
       if (!contents) {
          control.getPlan().setWaypoints([]);
          return false;
       }

       var params = Object.create(null),
           qs = contents.split("&"),
           plan = control.getPlan();

       for (var i = 0; i < qs.length; i++) {
          var item = qs[i].split("=",2);
          params[item[0]] = item[1];
       }

       // Parse the complete route before applying settings or waypoints. A broken
       // shared link must not leave the current route half updated.
       var wps = [], coordinates = [];
       if (params.wps !== undefined) {
          var wpqs = params.wps.split(/%7C|\|/i),
              skipSegments = {};
          if (params.ss) {
             var ss = params.ss.split(',');
             for (i = 0; i < ss.length; i++) {
                skipSegments[ss[i]] = true;
             }
          }

          var coordinatePattern = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i;
          for (i = 0; i < wpqs.length; i++) {
             var pair = wpqs[i].split(','),
                 latitude = pair.length === 2 ? pair[0].trim() : '',
                 longitude = pair.length === 2 ? pair[1].trim() : '',
                 lat = Number(latitude),
                 lng = Number(longitude);
             if (!coordinatePattern.test(latitude) || !coordinatePattern.test(longitude) ||
                 !isFinite(lat) || !isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) {
                plan.updateSettingsUI();
                control.fire('routingerror', {error: {message: L.localisation.get('error.invalidRouteLink')}});
                return false;
             }
             coordinates.push([lat, lng]);
          }
          for (i = 0; i < coordinates.length; i++) {
             wps.push({
                latLng: L.latLng(coordinates[i][0], coordinates[i][1]),
                name: null,
                options: {straightLines: skipSegments[i] === true}
             });
          }
       }

       var validBoolean = function(value) {
          return value === 'true' || value === 'false';
       };
       var validNumber = function(value, min, max) {
          return value !== undefined && String(value).trim() !== '' &&
                 isFinite(Number(value)) && Number(value) >= min && Number(value) <= max;
       };

       plan.clearRouteParameters();

       if (validBoolean(params.rt)) {
          plan.applyRouteParameters({
             roundTrip: params.rt == 'true',
             targetDistance: params.rt == 'true' ? (plan.getTargetDistance() || 5000) : 0
          });
       }

       if (validNumber(params.td, 0, Infinity) && (!plan.getRoundTrip() || Number(params.td) > 0)) {
          plan.applyRouteParameters({targetDistance: Number(params.td)});
       }

       if (validBoolean(params.aus2)) {
          plan.applyRouteParameters({avoidUnsafeStreets: params.aus2 == 'true'});
       }

       if (validBoolean(params.aus)) {
          plan.applyRouteParameters({avoidUnlitStreets: params.aus == 'true'});
       }

       if (params.ah === 'true') params.ah = -1;
       else if (params.ah === 'false') params.ah = 0;
       if (validNumber(params.ah, -1, 1)) {
          plan.applyRouteParameters({hillPreference: Number(params.ah)});
       }

       if (validBoolean(params.ar)) {
          plan.applyRouteParameters({avoidRepetition: params.ar == 'true'});
       }

       if (params.pga === 'true') params.pga = 0.8;
       else if (params.pga === 'false') params.pga = 0;
       if (validNumber(params.pga, 0, 1)) {
          plan.applyRouteParameters({greenPreference: Number(params.pga)});
       }

       if (validBoolean(params.im)) {
          plan.applyRouteParameters({imperialUnits: params.im == 'true'});
       }

       //plan.appliedLocationHash = true;

       plan.updateSettingsUI();

       if (params.wps !== undefined) {

          control.options.fitSelectedRoutes = true;

          plan.appliedLocationHash = wps.length > 1 && plan.getTargetDistance() > 0;

          plan._restoringLocationHash = true;
          try {
             plan.setWaypoints(wps);
          } finally {
             plan._restoringLocationHash = false;
          }

          control.options.fitSelectedRoutes = 'smart';

          if ( (plan.getRoundTrip() && wps.length >= 1) || wps.length >= 2)
             return true;
       }

       return false;
    }
    
});
